/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import CheckoutSelectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { setClickAnalyticsData, trackClick, trackFormError } from '@tcp/core/src/analytics/actions';
import SpcSelector from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import logger from '@tcp/core/src/utils/loggerInstance';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import {
  setCreateAccountTempPass,
  setIsNewUser,
  setIsRegisteredUser,
  fromPaymentMobile,
} from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.actions';
import InjectLoyaltyDynamicStore from '@tcp/core/src/components/features/CnC/LoyaltyBanner/container/LoyaltyDynamicStore';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import { getAddressAndCardList } from '@tcp/core/src/components/features/account/Payment/container/Payment.actions';
import constants from '../RewardsCard.constants';
import { setModuleX, obtainInstantCardApplication } from './ApplyCard.actions';
import {
  getUserInfo,
  setPlccCardIdActn,
  setPlccCardNumberActn,
} from '../../../account/User/container/User.actions';
import { isGuest } from '../../../CnC/Checkout/container/Checkout.selector';
import { getAddressList } from '../../../account/AddressBook/container/AddressBook.actions';
import { getModuleX } from '../../../../../services/abstractors/common/moduleXComposite';
import applyInstantCard from '../../../../../services/abstractors/common/PLCC';
import { validateReduxCache } from '../../../../../utils/cache.util';
import {
  getErrorMapping,
  getRtpsPreScreenData,
  getApplyCardModuleXComposite,
  getFromCardMobile,
} from './ApplyCard.selectors';
import BAG_PAGE_ACTIONS, {
  updateMiniBagFlag,
} from '../../../CnC/BagPage/container/BagPage.actions';
import {
  getIsMuleLogonApiEnable,
  getCartCacheTTL,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getUserInfoSaga } from '../../../account/User/container/User.saga';
import { getLoyaltyPointsRequestPayload } from '../../../CnC/BagPage/container/BagPage.selectors';
import { simulateLoyaltyDetail } from '../../../CnC/LoyaltyBanner/container/Loyalty.actions';
import { getOrderDetails } from '../../../CnC/CartItemTile/container/CartItemTile.selectors';
import { updateSectionState } from '../../../CnC/SinglePageCheckout/container/SinglePageCheckout.actions';
import {
  SECTION_MODE,
  SPC_SECTION,
} from '../../../CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import { getMyRewardCouponList } from '../../../CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import { resetCartCache } from '../../../CnC/BagPage/container/BagPage.saga';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import {
  getCartCachedDataForPLCC,
  getCurrentOrderFormatter,
} from '../../../../../services/abstractors/SFCC/CartItemTile';

const { getIsRtpsFlow } = CheckoutSelectors;

function getRequiredList3Vals(payload) {
  const {
    firstName,
    middleNameInitial,
    lastName,
    addressLine1,
    addressLine2,
    city,
    noCountryZip,
    statewocountry,
    phoneNumberWithAlt,
    altPhoneNumber,
    emailAddress,
    month,
    date,
    year,
    ssNumber,
  } = payload;
  return {
    firstName,
    middleNameInitial,
    lastName,
    addressLine1,
    addressLine2,
    city,
    noCountryZip,
    statewocountry,
    phoneNumberWithAlt,
    altPhoneNumber,
    emailAddress,
    month,
    date,
    year,
    ssNumber,
  };
}

/*
 * @Generator - fetchModuleX Saga -
 * @params - payload - array of contentIds
 *
 * @description - Helper Saga function to fetch the richtext data from module X.
 */

export function* fetchModuleX({ payload = '' }) {
  try {
    const applyCardModuleX = yield select(getApplyCardModuleXComposite);
    const applyCardModuleXObjLen =
      applyCardModuleX &&
      Object.getOwnPropertyNames(applyCardModuleX) &&
      Object.getOwnPropertyNames(applyCardModuleX).length;
    if (!applyCardModuleX || !applyCardModuleXObjLen) {
      const result = yield call(getModuleX, payload);
      yield put(setModuleX(result));
    }
  } catch (err) {
    yield null;
  }
}

function* callAnalytics() {
  const name = 'PLCC_Submit132';
  const pageName = window && window.loyaltyLocation;
  pushEventToAdobeAnalytics('plcc_submit');

  yield put(
    setClickAnalyticsData({
      eventName: 'PLCC_Submit132',
      customEvents: ['event132'],
      loyaltyLocation: pageName,
    })
  );
  yield put(trackClick({ name }));
}

export function* updateLoyaltyPoints(isRTPSFlow, isPlccFromCheckout) {
  yield call(getUserInfoSaga, {});
  if (isRTPSFlow || isPlccFromCheckout) {
    yield call(resetCartCache);
    yield put(BAG_PAGE_ACTIONS.getCachedCartData({}));
  } else {
    const payload = yield select(getLoyaltyPointsRequestPayload);
    yield InjectLoyaltyDynamicStore();
    yield put(
      simulateLoyaltyDetail({
        ...payload,
        source: 'Cart',
      })
    );
  }
}
export function shouldMakeCreateAccountCall({ isRegistered, isMprIdExist }) {
  let callFlag = false;
  if (
    (isRegistered === true && isMprIdExist === false) ||
    (isRegistered === false && isMprIdExist === true) ||
    (isRegistered === false && isMprIdExist === false)
  ) {
    callFlag = true;
  }
  return callFlag;
}
export function isApproved(status) {
  return status === 'APPROVED';
}
/*
 * @Generator - submitCreditCardForm Saga -
 * @params - payload - form data for instant credit card form
 *
 * @description - Helper Saga function to submit the form.
 */

// eslint-disable-next-line sonarjs/cognitive-complexity
export function* submitCreditCardForm({ payload = '' }) {
  const { isPlccFromCheckout, ...args } = payload;
  try {
    yield put(setLoaderState(true));
    const labels = yield select(getErrorMapping);
    const { preScreenCode } = yield select(getRtpsPreScreenData);
    const orderDetails = yield select(getOrderDetails);
    const isRTPSFlow = yield select(getIsRtpsFlow);
    const isFromCardMobile = yield select(getFromCardMobile);
    const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
    const isMuleLogonApiEnabled = yield select(getIsMuleLogonApiEnable);
    const isSfccPlatform = !isMuleLogonApiEnabled;
    const cartItemsCount = yield call(readCookie, 'cartItemsCount');

    const res = yield call(
      applyInstantCard,
      args,
      labels,
      preScreenCode,
      isSPC,
      isRTPSFlow,
      orderDetails,
      isSfccPlatform
    );
    // GetRegisteredUserInfo post processWIC.
    if (res.newUser === true) {
      yield put(getUserInfo({ ignoreCache: true, apiSuccess: true }));
    }
    const isGuestCheck = yield select(isGuest);
    // For re-calculate loyalty points
    yield call(updateLoyaltyPoints, isRTPSFlow, isPlccFromCheckout);
    if (cartItemsCount > 0) {
      const cacheTTL = yield select(getCartCacheTTL);
      const cachedCartData = yield call(getCartCachedDataForPLCC, cacheTTL, true);
      const formattedRespons = getCurrentOrderFormatter(cachedCartData);
      yield put(BAG_PAGE_ACTIONS.getOrderDetailsCompleteApplePay(formattedRespons));
    }
    if (typeof res.status === 'string') {
      yield put(trackFormError({ formName: 'PLCCForm', formData: getRequiredList3Vals(payload) }));
    }
    yield put(obtainInstantCardApplication(res));
    yield put(setIsRegisteredUser(res.isRegistered));
    yield put(setIsNewUser(res.newUser));
    if (res?.signUpUserResponse?.encryptedPassword) {
      yield put(setCreateAccountTempPass(res.signUpUserResponse.encryptedPassword));
    }
    yield put(setPlccCardIdActn(res.onFileCardId || res.xCardId));
    yield put(setPlccCardNumberActn((res.cardNumber || '').substr(-4)));

    if (isRTPSFlow || isFromCardMobile || isSPC) {
      if (!isGuestCheck) {
        if (isPlccFromCheckout) {
          yield put(getAddressAndCardList({ ignoreCache: true }));
        } else yield put(getAddressList({ ignoreCache: true }));
        // SFCC-TODO: Will implement in phase 2
        // yield call(getCardList, { ignoreCache: true });
      }
      if ((isRTPSFlow || isSPC) && res?.status === constants.APPLICATION_STATE_APPROVED) {
        yield put(
          updateSectionState({
            id: SPC_SECTION.PAYMENT,
            section: {
              isExpanded: false,
              mode: SECTION_MODE.SECTION_VIEW_MODE,
            },
          })
        );
      }
      yield put(fromPaymentMobile(false));
      yield put(BAG_PAGE_ACTIONS.clearNonCachedCartDataTTL());
      yield put(
        BAG_PAGE_ACTIONS.getNonCachedCartData({
          disableLoading: true,
          isCheckoutFlow: true,
        })
      );
    }
    yield injectCouponDynamicStore();
    yield put(getMyRewardCouponList({ ignoreCache: true, fromPlcc: true }));
    yield put(updateMiniBagFlag(true));
    yield put(setLoaderState(false));
    yield call(callAnalytics);
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'Apply Card Saga - submitCreditCardForm',
        payloadRecieved: payload,
      },
    });
    yield put(setLoaderState(false));
    yield put(trackFormError({ formName: 'PLCCForm', formData: getRequiredList3Vals(payload) }));
    const ErrorForAA = 'form error:plcc';
    pushEventToAdobeAnalytics('form_error', ErrorForAA);
  } finally {
    yield put(setLoaderState(false));
  }
}

/*
 * @Generator - ApplyCreditCardSaga Saga -
 *
 * @description - Primary saga to yield moduleX data.
 */

export function* ApplyCreditCardSaga() {
  const cachedfetchModuleX = validateReduxCache(fetchModuleX);
  yield takeLatest(constants.FETCH_MODULEX_CONTENT, cachedfetchModuleX);
}

/*
 * @Generator - SubmitInstantCardApplication Saga -
 *
 * @description - Primary saga to submit the instant credit card form.
 */

export function* SubmitInstantCardApplication() {
  const cachedsubmitCreditCardForm = validateReduxCache(submitCreditCardForm);
  yield takeLatest(constants.SEND_INSTANT_CARD_APPLICATION, cachedsubmitCreditCardForm);
}

export default ApplyCreditCardSaga;
